import { useQueryClient } from "@tanstack/react-query";
import { VersionHistoryPanel } from "../../../../../components/drawing-tool/version-history";
import { ProductDetailsViewModel } from "../../types/productDetailsView.types";

interface HistoryTabProps {
  vm: ProductDetailsViewModel;
}

/**
 * "History" tab — thin host around the shared `VersionHistoryPanel` (see
 * ProductSummaryHistorySheet.tsx for the other host of the same panel), which
 * owns the grouped-by-version list, pagination, rename/edit-details, and the
 * per-calculation change-diff box. `heading={null}` because the tab bar
 * already labels this tab "History".
 */
const HistoryTab = ({ vm }: HistoryTabProps) => {
  const queryClient = useQueryClient();

  // The dropdown-data query drives Environmental Footprint's "latest calculation" lookup
  // (see EnvironmentalFootprintTab.tsx) -- activating/editing a version can change which
  // calculation that is, so it must be invalidated for that tab to stay in sync.
  const invalidateProductSummaryDropdownData = () =>
    queryClient.invalidateQueries([vm.productId, vm.defaultSalesUnit, "useGetProductSummaryHistory"]);

  return (
    <VersionHistoryPanel
      productId={vm.productId}
      salesUnitId={vm.defaultSalesUnit}
      isAverageProduct={vm.productIsAverage}
      heading={null}
      onVersionRestored={() => {
        invalidateProductSummaryDropdownData();
        if (vm.productIsAverage) {
          queryClient.invalidateQueries(["average-product-summary", vm.productId]);
        }
      }}
      onVersionMetadataChanged={invalidateProductSummaryDropdownData}
    />
  );
};

export default HistoryTab;
